import type { SliderConfig } from './types';

export const CONFIG_DEFAULT: SliderConfig = {
  width: [156, 181, 204, 234],
  gap: [8, 12, 12, 16],
};

export const CONFIG_DEFAULT_SMALL: SliderConfig = {
  width: [156, 181, 153, 176],
  gap: [8, 12, 12, 16],
};

export const CONFIG_DRAWER: SliderConfig = {
  width: [120, 136, 144, 200],
  gap: [8, 8, 8, 12],
};

export const CONFIG_DRAWER_SMALL: SliderConfig = {
  width: [120, 136, 108, 150],
  gap: [8, 8, 8, 12],
};

export const CONFIG_WITH_BACKGROUND: SliderConfig = {
  width: [120, 136, 144, 200],
  gap: [8, 8, 8, 12],
};

export const CONFIG_WITH_BACKGROUND_SMALL: SliderConfig = {
  width: [120, 136, 108, 150],
  gap: [8, 8, 8, 12],
};

export const DY_SELECTOR = 'H24_{LOCALE}_x_AddToCart_Reco';

export const LABELS_BOTTOM = ['sp_4', null, null, 'sp_8'];
export const LABELS_LEFT = ['sp_4', null, null, 'sp_8'];
